const Backbone = require('backbone');
const Mn = require('backbone.marionette');

const Template = require('view');
const tpl = require('./index.twig');
/*
	model: {
		busca
		page
		rows
		filtros
		sort
		order
	}
*/	


/*
const View = Backbone.View.extend({
	initialize: function() {
		var that = this;	
		that.collection = new Backbone.Collection();

		that.search();

		that.render();
	},
	search: function() {
		var that = this;

		var busca = that.model.get('busca');

		var query = `
			{
			  produtos (busca:"${busca}", page: 1, rows: 10000) {
				id
				ordenamento
			    titulo
			    promocao
			    mostrar_loja
			    imagem {
			      path
			    }
			    porcoes {
			      id
			      titulo
			      valor
			      valor_promocional
			      calorias
			      estoque
			    }
			    filtros {
			      id
			      imagem
			      titulo
			    }
			    
			  }
			  
			  kits (busca:"${busca}", page:1, rows: 10000) {
			    id
			    ordenamento
			    imagem
			    tipo
			    titulo
			    valor
			    valor_promocional
			    editavel
			    promocao
			    filtros {
			      id
			      imagem
			      titulo
			    }
			    porcoes {
			      id
			      titulo
			      valor
			      valor_promocional
			      calorias
			      estoque
			    }
			  }
			}
		`;
		that.model.set('carregando',true);
		$.ajax({
			url: 'api/index.php',
			type: 'post',
			dataType: 'json',
			data: {
				query: query
			},
			success: function(resp) {
				var data = resp.data;

				var itens = [];

				data.produtos.forEach(function(produto){
					produto.uid = produto.id;
					produto.id = 'produto.'+produto.id
					itens.push(produto);
				});
				data.kits.forEach(function(kit){
					kit.uid = kit.id;
					kit.id = 'kit.'+kit.id
					itens.push(kit);
				});

				itens.sort(function(a, b) {
					if (a.ordenamento == b.ordenamento) return 0;
					return a.ordenamento < b.ordenamento ? 1 : -1;
				});

				that.collection.set(itens);

				that.model.set('carregando',false);

			},
			error: function() {
				that.model.set('carregando',false);
			}
		});

	},
	render: function() {
		var that = this;

		var data = that.model.toJSON();
		data.itens = that.collection.toJSON();

		that.$el.html(View.renderString(tpl, data));

	}
});
*/

const ResultadosView = require('./resultados');

const View = Mn.View.extend({
	template: tpl,
	initialize: function() {
		
		this.search();
		console.log('busca/index.js:initialize');

		this.render();	
	},
	search: function() {
		var that = this;

		var busca = that.model.get('busca');

		var query = `
			{
			  produtos (busca:"${busca}", page: 1, rows: 10000) {
				id
				ordenamento
			    titulo
			    promocao
			    mostrar_loja
			    imagem {
			      path
			    }
			    porcoes {
			      id
			      titulo
			      valor
			      valor_promocional
			      calorias
			      estoque
			    }
			    filtros {
			      id
			      imagem
			      titulo
			    }
			    
			  }
			  
			  kits (busca:"${busca}", page:1, rows: 10000) {
			    id
			    ordenamento
			    imagem
			    tipo
			    titulo
			    valor
			    valor_promocional
			    editavel
			    promocao
			    filtros {
			      id
			      imagem
			      titulo
			    }
			    porcoes {
			      id
			      titulo
			      valor
			      valor_promocional
			      calorias
			      estoque
			    }
			    refeicoes {
			    	dia
			    	porcoes {
			    		id
			    		titulo
			    		valor
			    		valor_promocional
			    		calorias
			    		estoque
			    	}
			    }
			  }
			}
		`;
		that.model.set('carregando',true);
		$.ajax({
			url: 'api/index.php',
			type: 'post',
			dataType: 'json',
			data: {
				query: query
			},
			success: function(resp) {
				var data = resp.data;

				var itens = [];

				data.produtos.forEach(function(produto){
					produto.uid = produto.id;
					produto.id = 'produto.'+produto.id;
					produto.controller = 'produto';
					itens.push(produto);
				});
				data.kits.forEach(function(kit){
					kit.uid = kit.id;
					kit.id = 'kit.'+kit.id;
					kit.controller = 'kit';

					if (kit.tipo == 'Kit') {
						kit.calorias = kit.porcoes.reduce(function(r,porcao) {
							return porcao.calorias+r;
						},0.0);
					} else {
						kit.dias = kit.refeicoes.reduce(function(dias, refeicao) {
							if (-1 == dias.indexOf(refeicao.dia)) {
								dias.push(refeicao.dia);
							}
							return dias;
						},[]).length;

						kit.calorias = kit.refeicoes.reduce(function(calorias, refeicao) {
							refeicao.calorias = refeicao.porcoes.reduce(function(c, porcao) {
								return c + porcao.calorias;
							},0.0);

							return calorias + refeicao.calorias;
						},0.0) / kit.dias;
					}

					itens.push(kit);
				});

				itens.sort(function(a, b) {
					if (a.ordenamento == b.ordenamento) return 0;
					return a.ordenamento < b.ordenamento ? 1 : -1;
				});

				that.collection.set(itens);

				that.model.set('carregando',false);

			},
			error: function() {
				that.model.set('carregando',false);
			}
		});

	},
	collectionEvents: {
		'update': 'render'
	},
	modelEvents: {
		'change carregando': 'render'
	},
	regions: {
		resultados: '.resultados',
		paginacao: '.paginacao',
		filtros: '.filtros'
	},
	onRender: function() {
		console.log('busca/index.js:onRender');
		this.showChildView('resultados', new ResultadosView({
			collection: this.collection,
			model: this.model
		}));
	}
});
View.setRenderer(function(template, data) {
	return Template.renderString(template, data);
});


module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/busca/index.js
// module id = 50
// module chunks = 0